import React from "react";
import './HowToParticipate.css'

const HowToParticipate = () => (
  <section className="how-to-participate">
    <h2>Cómo Participar</h2>
    <ol>
      <li><strong>Selecciona tu número:</strong> Elige del 000 al 999.</li>
      <li><strong>Paga $200 por cada numero:</strong> Contactanos al Whatsapp <a href="https://w.app/MegalotoTrimmerBuda">+57 3133956853</a> y te guiamos en este proceso</li>
      <li><strong>Confirma tu participación:</strong> envia tu compobante de pago con los numeros seleccionados.</li>
      <li><strong>Espera el sorteo:</strong> ¡Podrías llevarte estas dos máquinas!</li>
    </ol>
  </section>
);

export default HowToParticipate;
